import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
  Button,
  Block,
  BlockDes,
  BlockHead,
  Icon,
  Col,
  Row,
  PreviewAltCard,
} from "../../../components/Component";
import { Modal, Spinner, ModalBody, Form } from "reactstrap";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import AdminDashboardCount from "./AdminDashboardCount";
import TradeDetail from "./TradeDetail";
import AnnualTargetA from "./AnnualTargetA";
import FinancialYear from "../../components/DynmicOption/FinancialYear";

const AdminDashboard = ({ ...props }) => {
  const [transData, setTransData] = useState([]);
  const [monthdata, setmonthdata] = useState([]);
  const [useridd, setuseridd] = useState(0);
  const [onSearchText, setSearchText] = useState("");
  const month1 = [
    "Test",
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];
  const [modal, setModal] = useState({
    add: false,
  });
  const [modal1, setModal1] = useState({
    add: false,
  });

  const today = new Date();
  const [lorder, setLorder] = useState(true);
  const [domainf, setdomainf] = useState([]);
  const [data, setData] = useState(transData);
  const [formData, setFormData] = useState(() => {
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    const storedCurrentMonth = sessionStorage.getItem("CurrentMonth");
    const storedFinancialYear = sessionStorage.getItem("CurrentFinancialYear");
    const storedFinancialYearToSame = sessionStorage.getItem(
      "CurrentFinancialYearTosame"
    );

    const month =
      storedCurrentMonth === null ? currentMonth : Number(storedCurrentMonth);
    const dummymonth =
      storedCurrentMonth === null
        ? month1[currentMonth]
        : month1[Number(storedCurrentMonth)];
    const toyear =
      storedFinancialYearToSame === null
        ? currentYear + 1
        : Number(storedFinancialYearToSame);
    const year = storedFinancialYear === null ? currentYear : Number(storedFinancialYear);

    return {
      month,
      dummymonth,
      year,
      toyear,
    };
  });

  const [userData, setuserData] = useState(null);
  const [data2, setData2] = useState({
    labels: ["Deaft", "Submitted"],
    dataUnit: "People",
    legend: false,
    datasets: [
      {
        borderColor: "#fff",
        backgroundColor: ["#f9db7b", "#1ee0ac"],
        data: [2, 1],
      },
    ],
  });
  const tableRef = useRef(null);
  const changedata = async (activestatus) => {
    setLorder(true);
    const sendData = {
      EmploymentRefId: Number(10),
    };
    await fetch(
      process.env.REACT_APP_API_LINK + "api/Main/GetparametersNumber",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setTransData(data);
        setdomainf(data);
        setLorder(false);
      });
  };
  const getdata = async () => {
    const sendData = {
      EmploymentRefId: Number(formData.EmploymentRefId),
    };
    await fetch(
      process.env.REACT_APP_API_LINK + "api/Main/GetparametersNumber",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        changedata();
        setLorder(false);
      });
  };

  const getdatadash = async () => {
    const sendData = {
      OrgId: Number(2),
      UserId: Number(localStorage.getItem("userIdA")),
    };
    await fetch(
      process.env.REACT_APP_API_LINK + "api/NCSCDA/DashboardDataAdmin",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setmonthdata(data);
      });
  };
  const getdatadash2 = async () => {
    const sendData = {
      UserId: Number(localStorage.getItem("userIdA")),
      Apikey1: String(Number(formData.toyear) - 1),
      Apikey2: String(formData.toyear),
    };
    
    await fetch(process.env.REACT_APP_API_LINK + "api/NCSCDA/DashboardData2", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        const edit = data.filter((a) => a.activeStatus === "A");
        const sub = data.filter((a) => a.activeStatus === "S");
        setData2({
          labels: ["Draft", "Submitted"],
          dataUnit: "People",
          legend: false,
          datasets: [
            {
              borderColor: "#fff",
              backgroundColor: ["#f9db7b", "#1ee0ac"],
              data: [edit.length, sub.length],
            },
          ],
        });
      });
  };
  const usergetdata = async () => {
    const sendData = {
      UserId: Number(localStorage.getItem("userId")),
    };

    await fetch(process.env.REACT_APP_API_LINK + "api/Payment/Getuser", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log(data)
        setuserData(data);
      });
  };

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  /*const onInputChange3 = (month, year) => {
        setFormData({ ...formData, year: year });


    };*/
  const onInputChange3 = (e) => {
    setFormData({
      ...formData,
      year: e.target.value,
      toyear: Number(e.target.value) + 1,
    });
    sessionStorage.setItem("CurrentFinancialYear", e.target.value);
    sessionStorage.setItem(
      "CurrentFinancialYearTosame",
      Number(e.target.value) + 1
    );
  };
  const onInputChange2 = (tomonth, toyear) => {
    setFormData({ ...formData, toyear: toyear });
  };
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = transData.filter((item) => {
        return item.name.toLowerCase().includes(onSearchText.toLowerCase());
      });
      setTransData([...filteredObject]);
    } else {
      setTransData([...domainf]);
    }
  }, [onSearchText]);

  useEffect(() => {
    getdatadash();
    getdatadash2();
    getdata();
    //usergetdata()
  }, [formData.year, formData.toyear]);

  // function to reset the form
  const resetForm = () => {
    setFormData({
      organization: "",
      desiganationyear: "",
      designation: "",
      search: "",
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setModal({ add: false });
    resetForm();
  };
  const viewpage = async (userid) => {
    localStorage.setItem("userId", userid);
    window.location.pathname = "/Dashboard";
  };
  const update = () => {
    Swal.fire({
      icon: "success",
      title: "Done",
      text: "Updated Successfully",
      focusConfirm: false,
    });
    getdatadash();
    getdatadash2();
    getdata();
    usergetdata();
  };
  return (
    <React.Fragment>
      <Head title="Admin Dashboard" />

      <Content>
        <Block>
          <BlockHead size="lg">
            <BlockDes className="text-soft">
              <Row>
                <Col xl="4" md="4">
                  <td>
                    <h5 style={{ color: "#798bff" }}>Admin Dashboard</h5>
                  </td>
                </Col>
                <Col xl="4" md="4">
                  <td>
                    <h5 style={{ color: "#798bff" }}>Financial Year Filter</h5>
                  </td>
                </Col>
                <Col xl="4" md="4">
                  <label style={{ color: "black", fontSize: 15 }}>
                    {" "}
                    <label style={{ fontWeight: "bold" }}>
                      <FinancialYear
                        defaultValuemain={`${Number(formData.toyear) - 1}-${
                          formData.toyear
                        }`}
                        catid="42"
                        onInputChange={onInputChange3}
                        namemain="year"
                        mainid="year"
                      />
                    </label>
                  </label>
                </Col>

                {/*<Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 15 }}>  <label style={{ fontWeight: 'bold' }}><FinancialYearTo defaultValuemain={formData.toyear} year={formData.toyear} fromyear={Number(formData.year) + 1} onInputChange={onInputChange2} month={formData.month} /></label></label>
                                     
                                  
                                    </Col>*/}
              </Row>
              <hr />
              <Row>
                <Col md="4" xxl="4">
                  <PreviewAltCard border1={true} className="h-100">
                    <h6 className="ff-base fw-medium">
                      <b style={{ fontSize: 20 }}> Summary</b> :<br />
                      <br />{" "}
                      <small className="text-soft">
                        This is Admin Dashboard Shows The Statements of physical
                        progress of NCSC-DA s
                      </small>
                    </h6>
                  </PreviewAltCard>
                </Col>
                <Col md="8" xxl="8">
                  <PreviewAltCard border1={true} className="h-100">
                    <Row>
                      <Col md="2"></Col>
                      <Col md="6">
                        <div className="traffic-channel-group">
                          <div>
                            <div className="title">
                              <span
                                className="dot dot-lg sq"
                                style={{ background: "#f9db7b" }}
                              ></span>
                              <b style={{ fontSize: 20 }}>
                                {" "}
                                Draft :{" "}
                                <large style={{ marginLeft: 80 }}>
                                  {" "}
                                  {data2.datasets[0].data[0]}
                                </large>{" "}
                              </b>
                            </div>
                            <div className="amount"></div>
                          </div>

                          <div>
                            <div className="title">
                              <span
                                className="dot dot-lg sq"
                                style={{ background: "#1ee0ac" }}
                              ></span>
                              <b style={{ fontSize: 20 }}>
                                {" "}
                                Submitted :{" "}
                                <large style={{ marginLeft: 32 }}>
                                  {" "}
                                  {data2.datasets[0].data[1]}
                                </large>
                              </b>
                            </div>
                            <div className="amount"></div>
                          </div>
                          <div>
                            <div className="title"></div>
                            <div className="amount"></div>
                          </div>
                        </div>
                      </Col>
                      <Col md="4">
                        <div className="traffic-channel-doughnut-ck">
                          <Doughnut
                            className="analytics-doughnut"
                            data={data2}
                            options={{
                              legend: {
                                display: false,
                              },
                              rotation: -1.5,
                              cutoutPercentage: 70,
                              maintainAspectRatio: false,
                              tooltips: {
                                enabled: true,
                                backgroundColor: "#fff",
                                borderColor: "#eff6ff",
                                borderWidth: 2,
                                titleFontSize: 13,
                                titleFontColor: "#6783b8",
                                titleMarginBottom: 6,
                                bodyFontColor: "#9eaecf",
                                bodyFontSize: 12,
                                bodySpacing: 4,
                                yPadding: 10,
                                xPadding: 10,
                                footerMarginTop: 0,
                                displayColors: false,
                              },
                            }}
                          ></Doughnut>
                        </div>
                      </Col>
                    </Row>
                  </PreviewAltCard>
                </Col>
              </Row>
            </BlockDes>
          </BlockHead>

          <div className="table-responsive">
            <table className="table table-orders" ref={tableRef}>
              <thead className="tb-odr-head">
                <tr className="tb-odr-item">
                  <th>S.No</th>
                  <th>Center</th>
                  <th>Draft</th>
                  <th>Submit</th>
                  <th>Action</th>
                  <th>Trade</th>

                  <th>Annual Target</th>
                </tr>
              </thead>

              <tbody>
                {monthdata.length === 0 ? (
                  <Spinner color="success" />
                ) : (
                  monthdata.map((datamain, index) => (
                    <tr key={index} className="tb-odr-item">
                      <td>
                        <a
                          href="#id"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                        >
                          <b style={{ fontSize: 18 }} key={index}>
                            {index + 1}
                          </b>
                        </a>
                      </td>

                      <td>
                        <a
                          href="#id"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                        >
                          <b style={{ fontSize: 18 }}>{datamain.state}</b>
                        </a>
                      </td>
                      <AdminDashboardCount
                        userid={datamain.userId}
                        fromyear={formData.year}
                        toyear={formData.toyear}
                      />

                      <td>
                        <Button
                          color="primary"
                          onClick={(ev) => {
                            ev.preventDefault();
                            viewpage(datamain.userId);
                          }}
                        >
                          <b style={{ fontSize: 18 }}>
                            View <em className="icon ni ni-eye-fill"></em>
                          </b>
                        </Button>
                      </td>
                      <td>
                        <Button
                          color="success"
                          onClick={() => (
                            setModal({ add: true }), setuseridd(datamain.userId)
                          )}
                        >
                          {" "}
                          <b style={{ fontSize: 18 }}>
                            Trade <em className="icon ni ni-growth-fill"></em>
                          </b>
                        </Button>
                      </td>
                      <td>
                        <Button
                          color="warning"
                          onClick={() => (
                            setModal1({ add: true }),
                            setuseridd(datamain.userId)
                          )}
                        >
                          {" "}
                          <b style={{ fontSize: 18 }}>
                            Annual Target{" "}
                            <em className="icon ni ni-edit-alt-fill"></em>
                          </b>
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {monthdata.length === 0 ? (
              <center>
                <h4>No Data Found</h4>{" "}
              </center>
            ) : null}
          </div>

          <Modal
            isOpen={modal.add}
            toggle={() => setModal({ add: false })}
            className="modal-dialog-centered"
            size="lg"
          >
            <ModalBody>
              <a
                href="#cancel"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
                className="close"
              >
                <Icon name="cross-sm"></Icon>
              </a>
              <div className="p-2">
                <h5 className="title">Add Trade</h5>
                <div className="mt-4">
                  <Form className="row gy-4 mt-4">
                    <input
                      style={{
                        height: 40,
                        fontSize: 20,
                        border: "1px solid black",
                        margin: 20,
                      }}
                      type="text"
                      name="search"
                      className="form-control border-transparent form-focus-none"
                      placeholder="Search by Trade Name "
                      value={onSearchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                    <ul className="custom-control-group">
                      {transData === [] ? (
                        <Spinner color="success" />
                      ) : (
                        transData.map((datamainn, index) =>
                          datamainn.parentId === -5 ? (
                            <TradeDetail
                              name={datamainn.name}
                              key={index}
                              index={index}
                              parametersId={datamainn.parametersId}
                              useridd={useridd}
                            />
                          ) : null
                        )
                      )}
                    </ul>

                    <Col size="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              onFormCancel();
                            }}
                            className="link link-light"
                          >
                            <Button color="danger" size="md">
                              <em className="icon ni ni-cross"></em> Close
                            </Button>
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Form>
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={modal1.add}
            toggle={() => setModal1({ add: false })}
            className="modal-dialog-centered"
            size="lg"
          >
            <ModalBody>
              <a
                href="#cancel"
                onClick={(ev) => {
                  ev.preventDefault();
                  setModal1({ add: false });
                }}
                className="close"
              >
                <Icon name="cross-sm"></Icon>
              </a>
              <div className="p-2">
                <h5 className="title">Add Target</h5>
                <div className="mt-4">
                  <Form className="row gy-4 mt-4">
                    {transData === [] ? (
                      <Spinner color="success" />
                    ) : (
                      transData.map((datamainn, index) =>
                        datamainn.parentId === -8 ? (
                          <AnnualTargetA
                            key={index}
                            name={datamainn.name}
                            parametersId={datamainn.parametersId}
                            useridd={useridd}
                          />
                        ) : null
                      )
                    )}

                    <Col size="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setModal1({ add: false });
                            }}
                            className="link link-light"
                          >
                            <Button
                              color="success"
                              size="md"
                              onClick={() => update()}
                            >
                              <Icon name="update" /> Update
                            </Button>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setModal1({ add: false });
                            }}
                            className="link link-light"
                          >
                            <Button color="danger" size="md">
                              <em className="icon ni ni-cross"></em> Close
                            </Button>
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Form>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default AdminDashboard;
